module.exports = __webpack_public_path__ + "img/Marca8.77021c7a.jpg";